import { Card, useTheme, Box, CardHeader, CardContent } from "@mui/material";
import React from "react";

const CustomCard = ({ children, title, subHeader, sx ,action}) => {
  const theme = useTheme();
  return (
    <Card sx={{ width: '100%', maxWidth: '100%', overflow: 'hidden' }}>
      <Box
        sx={{
          width: "100%",
          height: 4,
          backgroundColor: theme.palette.primary.main,
        }}
      />
      <CardHeader
        title={title}
        subheader={subHeader}
        action={action}
        titleTypographyProps={{ variant: "subtitle1", fontWeight: 600 }}
        sx={{
          backgroundColor: theme.palette.grey[50],
          '& .MuiCardHeader-content': { minWidth: 0 },
          '& .MuiCardHeader-action': {
            margin: 0,
            alignSelf: 'center',
            flexShrink: 1,
            maxWidth: '100%',
          },
        }}
      />
      <CardContent sx={sx}>{children}</CardContent>
    </Card>
  );
};

export default CustomCard;
